import type { Dispatch, SetStateAction } from 'react';
import type { NextRouter } from 'next/router';
import type { PaymentContextType } from '../../../context/paymentContext';
import type { PaymentResponseType } from '../../../types';
import { PaymentResultCode } from '../../../types/adyen';
import { createAnchorTagHref, paymentRefusalReason, setItem } from '../../../utils';
import { newRelicAvailabilityChecker } from '../../../utils/newrelic';

interface HandlePaymentCompletedProps {
  router: NextRouter;
  cartId: string;
  locale: string;
  result: PaymentResponseType;
  paymentData: PaymentContextType['paymentData'];
  setPaymentError: Dispatch<SetStateAction<boolean>>;
  setPaymentInProgress: Dispatch<SetStateAction<boolean>>;
  setIsPaymentBtnDisabled: Dispatch<SetStateAction<boolean>>;
}

export const handlePaymentCompleted = ({
  router,
  cartId,
  locale,
  result,
  paymentData,
  setPaymentError,
  setPaymentInProgress,
  setIsPaymentBtnDisabled,
}: HandlePaymentCompletedProps) => {
  newRelicAvailabilityChecker(() => {
    window.newrelic.addPageAction('checkout_payment_completed', {
      cart_id: cartId,
      payment_result: result.resultCode !== undefined ? result.resultCode : '',
      payment_session_id: paymentData?.session.id,
    });
  });

  setPaymentError(paymentRefusalReason(result.resultCode));

  if (result?.resultCode === PaymentResultCode.AUTHORISED || result?.resultCode === PaymentResultCode.RECEIVED) {
    router.push(
      {
        pathname: createAnchorTagHref({ locale, path: '/checkout/confirmation' }),
      },
      undefined,
      {
        shallow: true,
      },
    );

    setItem('PAYMENT_RESULT_CODE', result.resultCode, true, 'sessionStorage');
  } else {
    setPaymentInProgress(false);
    setIsPaymentBtnDisabled(false);
  }
};
